import { useMemo } from "react";
import { markdownToHtml, stripLeadingH1 } from "@/lib/markdown";

/**
 * PieceBody — renders the piece's draft body as HTML.
 *
 * Renamed from ArticleBody in S-086 / FEAT-006 (Piece is the
 * production unit name; see project_piece_naming memory). CSS
 * classes (`article-body`, `article-body-md`) are kept as-is —
 * they're cosmetic, decoupled from the data concept, and renaming
 * them would touch global stylesheets without changing behavior.
 */
export function PieceBody({
  markdown,
  stripTitle = false,
}: {
  markdown: string | null | undefined;
  stripTitle?: boolean;
}) {
  const html = useMemo(
    () => markdownToHtml(stripTitle ? stripLeadingH1(markdown) : markdown),
    [markdown, stripTitle]
  );
  if (!html) {
    return (
      <div className="article-body article-body-md">
        <p style={{ color: "var(--muted-fg)", fontStyle: "italic" }}>
          No draft body yet. The Writer hasn't run on this piece.
        </p>
      </div>
    );
  }
  return (
    <div
      className="article-body article-body-md"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
